import { render, staticRenderFns } from "./CrudCourse.vue?vue&type=template&id=a92f724c&scoped=true&"
import script from "./CrudCourse.vue?vue&type=script&lang=js&"
export * from "./CrudCourse.vue?vue&type=script&lang=js&"
import style0 from "./CrudCourse.vue?vue&type=style&index=0&id=a92f724c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f724c",
  null
  
)

export default component.exports